import { render, staticRenderFns } from "./AmButton.vue?vue&type=template&id=a8ca7966&scoped=true&"
import script from "./AmButton.vue?vue&type=script&lang=js&"
export * from "./AmButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ca7966",
  null
  
)

export default component.exports